import * as serviceWorker from './serviceWorker';
// Librairies
import * as Sentry from '@sentry/react';
import { i18nReady } from './locales/i18n';

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// L'application (bootstrap.js) n'est exécutée qu'une fois la langue chargée : beaucoup de ses modules appellent i18n.t dès leur import.
// « eager » la garde dans main.js (pas de requête de plus, même ordre des feuilles de style) ; seule son exécution est différée.
// Si la langue ne se charge pas, l'application démarre quand même (les clés sont en français)
i18nReady.catch(() => null).then(() => import(/* webpackMode: "eager" */ './bootstrap'));

// Offline mode
serviceWorker.register();